export const monthsData = [
  // { label: "Month", value: 0, disabled: true },
  { label: "January", value: 0 },
  { label: "February", value: 1 },
  { label: "March", value: 2},
  { label: "April", value: 3 },
  { label: "May", value: 4 },
  { label: "June", value: 5 },
  { label: "July", value: 6 },
  { label: "August", value: 7 },
  { label: "September", value: 8 },
  { label: "October", value: 9 },
  { label: "November", value: 10 },
  { label: "December", value: 11 },
  { label: "YTD", value: "YTD" },
];

export const yearData = [
  { label: "2023", value: 2023 },
  { label: "2024", value: 2024 },
  { label: "2025", value: 2025 },
];

export const RevenueType = [
  // {
  //   label: "Cost Revenue",
  //   value: "Cost Revenue",
  // },
  {
    label: "Service",
    value: "Service",
  },
  {
    label: "Alcohol Commission",
    value: "Alcohol Commission",
  },
  {
    label: "Combined",
    value: "Combined",
  },
];
